import type { WidgetView } from "@/store/view-store";
import { useAuthStore } from "@/store/auth-store";
import { useScheduleStore } from "@/store/schedule-store";
import { useViewStore } from "@/store/view-store";
import type { ClassSession } from "@/types/ClassSession";

// Liens internes du widget : des ancres que WidgetLink traduit en changement
// d'etat, l'iframe ne navigue jamais.

export const weekHref = (start: string | null) => `#week=${start ?? ""}`;
export const viewHref = (view: WidgetView) => `#view=${view}`;
export const classHref = (classSessionId: string) => `#class=${classSessionId}`;
export const videoHref = (slug: string) => `#video=${encodeURIComponent(slug)}`;
export const programmeHref = (slug: string) => `#programme=${encodeURIComponent(slug)}`;

export function followWidgetHref(href: string) {
  const [kind, value = ""] = href.replace(/^#/, "").split("=");

  switch (kind) {
    case "week":
      useScheduleStore.getState().setWeek(value || null);
      return;
    case "view":
      useViewStore.getState().navigate(value as WidgetView);
      return;
    case "video":
      useViewStore.getState().openVideo(decodeURIComponent(value));
      return;
    case "programme":
      useViewStore.getState().openProgramme(decodeURIComponent(value));
      return;
    case "class":
      // L'ecran de paiement recharge la seance a partir de son id.
      useViewStore
        .getState()
        .setSelectedEvent({ id: value } as ClassSession, useAuthStore.getState().isAuthenticated);
      return;
  }
}
